// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#camera_list_tab[data-v-65f8d5d8] {\n  min-height: 60vh;\n}\n#split_screen_tab[data-v-65f8d5d8] {\n  color: white;\n  min-height: 60vh;\n}", ""]);
// Exports
module.exports = exports;
